import { Address } from '../interfaces'

export const formatAddress = (address: Address): string =>
  address.street ? `${address.street} , ${address.zip} ${address.city}`.trim() : `${address.zip} ${address.city}`.trim()
